const flags = {
	admin: {
		contactsLeadScore: 'admin:contacts_lead_score',
		disableContactInvite: 'admin:disable_contact_invite',
		exportContacts: 'admin:export_contacts',
		groupSelection: 'admin:group_selection',
		groupsSubscriptionBadge: 'admin:groups_subscription_badge',
		leadScoreHistoryModal: 'admin:lead_score_history_modal',
		resendAgentInvite: 'admin:resend_agent_invite',
		resendInvite: 'admin:resend_invite',
		searchContacts: 'admin:search_contacts',
		showFieldOfficeSlug: 'admin:show_field_office_slug',
		showPremiumAgentBadge: 'admin:show_premium_agent_badge',
	},
	agent: {
		ads: 'agent:ads',
		avmLeadGenWidget: 'agent:avm_lead_gen_widget',
		avmLeadIdentification: 'agent:avm_lead_identification',
		blogLink: 'agent:blog_link',
		blogWidget: 'agent:blog_widget',
		contactAddress: 'agent:contact_address',
		contactAddressDetails: 'agent:contact_address_details',
		contactCommunicationPreferences:
			'agent:contact_communication_preferences',
		contactFinanceWidgets: 'agent:contact_finance_widgets',
		disableContactInvite: 'agent:disable_contact_invite',
		leadScoreHistoryModal: 'agent:lead_score_history_modal',
		limitContactsOnFreeAccounts: 'agent:limit_contacts_on_free_accounts',
		marketActivityEmail: 'agent:market_activity_email',
		marketplaceWidget: 'agent:marketplace_widget',
		mis: 'agent:mis',
		mortgageSection: 'agent:mortgage_section',
		propertyValuationAvms: 'agent:property_valuation_avms',
		propertyValuationHkAvm: 'agent:property_valuation_hk_avm',
		propertyValuationQuantariumAvm:
			'agent:property_valuation_quanterium_avm',
		publicPros: 'agent:public_pros',
		resendInvite: 'agent:resend_invite',
		sendContactImportReport: 'agent:send_contact_import_report',
		sendInvites: 'agent:send_invites',
		sendInvites17c19ed9aec5d4b41f33c56a:
			'agent:send_invites:17c19ed9aec5d4b41f33c56a',
		sendInvites6398cab166d2e8465807eb46:
			'agent:send_invites:6398cab166d2e8465807eb46',
		sendMarketActivity: 'agent:send_market_activity',
		showFieldUrlSlug: 'agent:show_field_url_slug',
		showValuationWidget: 'agent:show_valuation_widget',
		unsubscribeOver300: 'agent:unsubscribe_over_300',
	},
	agents: {
		connectionsZapier: 'agents:connections_zapier',
	},
	branding: {
		colorLogos: 'branding:color_logos',
		homeownerFinances: 'branding:homeowner_finances',
	},
	contacts: {
		disableInvites: 'contacts:disable_invites',
		misHistory: 'contacts:mis_history',
		mockRevaluate: 'contacts:mock_revaluate',
		moverScore: 'contacts:mover_score',
	},
	group: {
		showCobranding: 'group:show_cobranding',
	},
	homeowner: {
		ads: 'homeowner:ads',
		appliancesAd: 'homeowner:appliances_ad',
		avm: 'homeowner:avm',
		blogs: 'homeowner:blogs',
		checklistBanner: 'homeowner:checklist_banner',
		checklistRepairEstimate: 'homeowner:checklist_repair_estimate',
		comparableMarketActivity: 'homeowner:comparable_market_activity',
		financesPage: 'homeowner:finances_page',
		mortgageInformation: 'homeowner:mortgage_information',
		projects: 'homeowner:projects',
		showFullTeam: 'homeowner:show_full_team',
	},
	manager: {
		cobranding: 'manager:cobranding',
		contactAddress: 'manager:contact_address',
		contactAddressDetails: 'manager:contact_address_details',
		contactFinanceWidgets: 'manager:contact_finance_widgets',
		mis: 'manager:mis',
		mortgageSection: 'manager:mortgage_section',
		propertyValuationAvms: 'manager:property_valuation_avms',
		propertyValuationHkAvm: 'manager:property_valuation_hk_avm',
		propertyValuationQuantariumAvm:
			'manager:property_valuation_quanterium_avm',
		sendInvites: 'manager:send_invites',
		sendInvites17c19ed9aec5d4b41f33c56a:
			'manager:send_invites:17c19ed9aec5d4b41f33c56a',
		sendInvites6398cab166d2e8465807eb46:
			'manager:send_invites:6398cab166d2e8465807eb46',
		uploadProfile: 'manager:upload_profile',
	},
	subscription: {
		promotionCode: 'subscription:promotion_code',
	},
	vendor: {
		add: 'vendor:add',
		premiumExclusivity: 'vendor:premium_exclusivity',
		vendorExclusivity: 'vendor:exclusivity',
	},
};

export default flags;
